<template>
  <div class="d-flex flex-column flex-grow-1">
    <div>
      <div class="display-1">RFQ</div>
      <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
      <v-row>
        <v-col cols="12">
          <v-btn
            class="text-capitalize"
            color="primary"
            outlined
            depressed
            :block="false"
            @click="goToProjectDetails"
            >Back to Project Details</v-btn
          >
        </v-col>
      </v-row>

      <v-card v-if="loading">
        <v-card-text>
          <Loading />
          <div class="text-center">
            <strong>Loading...</strong>
          </div>
        </v-card-text>
      </v-card>

      <v-tabs v-if="schedule" v-model="tab">
        <v-tab>Dealers</v-tab>
        <v-tab>
          <template v-if="projectRfqs.length > 0">
            <v-badge :content="projectRfqs.length">
              Sent
            </v-badge>
          </template>
          <template v-else>Sent</template>
        </v-tab>
        <v-tab>
          <template v-if="biddedRfqs.length > 0">
            <v-badge :content="biddedRfqs.length">
              Quotes
            </v-badge>
          </template>
          <template v-else>Quotes</template>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-if="schedule" v-model="tab">
        <v-tab-item>
          <Dealers :schedule="schedule" />
        </v-tab-item>
        <v-tab-item>
          <SentQuotes :schedule="schedule" />
        </v-tab-item>
        <v-tab-item>
          <ReceivedQuotes :schedule="schedule" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/common/Loading";
import Dealers from "@/components/rfq/contractor/Dealers";
import SentQuotes from "@/components/rfq/contractor/SentQuotes";
import ReceivedQuotes from "@/components/rfq/contractor/ReceivedQuotes";
import { mapState } from "vuex";
export default {
  components: {
    Loading,
    Dealers,
    SentQuotes,
    ReceivedQuotes
  },
  computed: {
    ...mapState({
      projectRfqs: state => state.rfq.project_rfqs
    }),
    biddedRfqs() {
      if (this.projectRfqs && this.projectRfqs.length > 0) {
        return this.projectRfqs.filter(
          rfq => rfq.status === "bided" && rfq.bids.length > 0
        );
      }

      return [];
    }
  },
  methods: {
    goToProjectDetails() {
      this.$router.push(
        `/project/${this.$route.params.id}/schedule/${this.$route.params.name}`
      );
    },
    getProjectSchedule() {
      const payload = {
        id: this.$route.params.id,
        name: this.$route.params.name
      };
      this.loading = true;
      this.$store
        .dispatch("schedule/getProjectSchedule", payload)
        .then(resp => {
          this.schedule = { ...resp.schedule };
        }).finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getProjectSchedule();
  },
  data() {
    return {
      loading: false,
      tab: 0,
      schedule: null,
      breadcrumbs: [
        {
          text: "Login",
          disabled: true,
          href: "/login"
        },
        {
          text: "Projects",
          to: "/"
        },
        {
          text: "Project Details",
          to: `/project/${this.$route.params.id}/schedule/${this.$route.params.name}`
        },
        {
          text: "RFQ"
        }
      ]
    };
  }
};
</script>
